/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { Link, graphql } from 'gatsby';
import styled from 'styled-components';

// eslint-disable-next-line import/no-cycle
import Layout from '../components/layout';
import SEO from '../components/seo';
import { HeroHeading, SmallTitle, BodyText } from '../components/Global';
import { Grid, GridItem } from '../components/Grid';
import { theme } from '../styles/GlobalStyles';

const Wrap = styled.div`
  width: 297px;
  margin: 2px auto 138px;

  h1 {
    color: ${theme.textColor.darkGrayText};
  }

  br {
    height: 0;
    margin: 0;
  }

  @media (min-width: 768px) {
    width: 628px;
    margin: 38px auto 150px;
  }

  @media (min-width: 990px) {
    width: 746px;
    margin: 40px auto 160px;
  }
`;

const BreadCrumb = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 7px;
  a {
    color: ${theme.textColor.linkText};
    :hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  span {
    margin: 10px 5px;
  }
`;

const ContentWrap = styled.div`
  margin-top: 17px;

  img {
    height: auto;
  }

  @media (min-width: 768px) {
    margin-top: 14px;
  }

  @media (min-width: 990px) {
    margin-top: 29px;
  }
`;

const MoreArticles = styled.div`
  width: 100%;
  margin-top: 48px;
  border-top: 0;

  li {
    
    &::marker {
      color: ${theme.textColor.silverText};
    }
    div {
      display: inline-block;
      width: 90%;
      margin-left: -10px;
      vertical-align: top;
      color: ${theme.textColor.blueText};
    }
    &:hover {
      div {
       text-decoration: underline;
      }
    }
  }

  @media (min-width: 768px) {
    border-top: 1px solid ${theme.borderColor.silver};
    margin-top: 57px; 
    padding-top: 60px;
  }
  @media (min-width: 990px) {
    margin-top: 88px;
  }
`;

export const HelpArticleContext = React.createContext({});

const helpArticleTemplate = ({
  data, location, pageContext: {
    article, folderArticles, folder
  }
}) => {
  let currentCategory = '';
  const articles = [];
  data.allContentfulHelpCategory.edges.forEach((item) => {
    if (item.node.categoryId === article.category_id.toString()) {
      currentCategory = item.node.categoryTitle;
    }
    return true;
  });
  folderArticles.forEach((item) => {
    if (item.status === 2 && item.title !== article.title) {
      articles.push(item);
    }
    return true;
  });
  return (
    <HelpArticleContext.Provider value={article}>
      <Layout location={location} isBlogPost>
        <SEO title={article.title} />
        <Wrap>
          <BreadCrumb>
            <Link to={`/help/categories/${article.category_id}`}>{currentCategory}</Link>
            <span> / </span>
            <Link to={`/help/categories/${article.category_id}/#${article.folder_id}`}>
              {folder.name}
            </Link>
          </BreadCrumb>
          <HeroHeading>{article.title}</HeroHeading>
          <ContentWrap dangerouslySetInnerHTML={{ __html: article.description }} />
          <MoreArticles>
            <SmallTitle mb="18px">
              {`More articles from ${currentCategory}`}
            </SmallTitle>
            <Grid gridGap="0" minCol="292px">
              <GridItem>
                {
                  articles.map((item, i) => {
                    if (i < Math.ceil(articles.length / 2)) {
                      return (
                        <BodyText mt="0" mb="12px" key={item.id}>
                          <Link to={`/help/articles/${item.id}`}><li><div>{item.title}</div></li></Link>
                        </BodyText>
                      );
                    }
                    return true;
                  })
                }
              </GridItem>
              <GridItem>
                {
                  articles.map((item, i) => {
                    if (i > Math.ceil(articles.length / 2) - 1) {
                      return (
                        <BodyText mt="0" mb="12px" key={item.id}>
                          <Link to={`/help/articles/${item.id}`}><li><div>{item.title}</div></li></Link>
                        </BodyText>
                      );
                    }
                    return true;
                  })
                }
              </GridItem>
            </Grid>
          </MoreArticles>
        </Wrap>
      </Layout>
    </HelpArticleContext.Provider>
  );
};

helpArticleTemplate.propTypes = {
  data: PropTypes.shape({
    allContentfulHelpCategory: PropTypes.shape({
      edges: PropTypes.shape({
        forEach: PropTypes.shape({
          categoryTitle: PropTypes.string,
          categoryId: PropTypes.string,
        }),
      }),
    }).isRequired,
  }).isRequired,
  pageContext: PropTypes.shape({
    article: PropTypes.shape({
      id: PropTypes.number,
      folder_id: PropTypes.number,
      category_id: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.element,
    }).isRequired,
    folder: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    category: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    folderArticles: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
      }).isRequired,
    ).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    host: PropTypes.string,
    hostname: PropTypes.string,
    href: PropTypes.string,
    key: PropTypes.string,
    origin: PropTypes.string,
    pathname: PropTypes.string,
    port: PropTypes.string,
  }).isRequired,
};

export default helpArticleTemplate;

export const pageQuery = graphql`
  query HelpArticleQuery {
    allContentfulHelpCategory {
      edges {
        node {
          categoryTitle
          categoryId
        }
      }
    }
  }
`;
